module.exports = __webpack_public_path__ + "static/media/img-merchant-wallet-new.3dbcfb58.pdf";